import { render, staticRenderFns } from "./rebirth.vue?vue&type=template&id=928b16d6&scoped=true"
import script from "./rebirth.vue?vue&type=script&lang=js"
export * from "./rebirth.vue?vue&type=script&lang=js"
import style0 from "./rebirth.vue?vue&type=style&index=0&id=928b16d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928b16d6",
  null
  
)

export default component.exports